import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideStore } from '@ngrx/store';
import { routes } from './app.routes';

import { authMetaReducer } from './store/auth/auth.metareducer';
import { authReducer } from './store/auth/auth.reducer';
import { provideHttpClient, withFetch } from '@angular/common/http';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideStore(
      {
        auth: authReducer,
      },
      { metaReducers: [authMetaReducer] }
    ),
    provideHttpClient(withFetch()),
  ]
};
